export const tourGuideSteps = [
  {
    selector: "#client-details-card",
    content:
      "This area shows the summary of the client details.",
  },
  {
    selector: "#search-token-details-card",
    content:
      "This is the list of search tokens associated with the message.",
  },
  {
    selector: "#connector-details",
    content:
      "Provides connector level detail of the message.",
  },
  {
    selector: "#discard-edit-buttons",
    content:
      "On page load, a copy of the original message is provided. The message can be edited and reprocessed as needed.",
  },
  {
    selector: "#reprocess-message-button",
    content:
      "Press this button once the message has been edited above.",
  },
];
